import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnswerList from '../answerList';
import './question.css';

class Question extends Component {
  state = {
    question: {},
    answer: false,
    answerValue: 0,
    count: 0,
    multipleChoice: false,
    answersMulti: null,
    groupResultInfo: [],
    groupName: null
  };

  componentDidMount() {
    this.updateQuestion();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.step !== this.props.step) this.updateQuestion();
  }

  updateQuestion() {
    const { questions, step } = this.props;

    const currentQuestion = questions[step - 1];

    const answers = currentQuestion.answers;

    const multi = answers.filter(item => item.isCorrect === true);
    const answersId = multi.map(item => item.id);

    this.setState({
      question: currentQuestion,
      answersMulti: answersId,
      answer: false
    });

    if (multi.length > 1) {
      this.setState({
        multipleChoice: true
      });
    } else {
      this.setState({
        multipleChoice: false
      });
    }
  }

  onChangeAnswer = (e, groupName) => {
    const answers = this.state.question.answers;
    let value = +e.target.value;

    answers.forEach(item => {
      if (item.id === value && item.isCorrect === true) {
        this.setState(
          {
            count: this.state.count + 1
          },
          () => {
            this.props.updateCount(this.state.count);
          }
        );
      }

      this.setState({
        answer: true,
        answerValue: value
      });

      if(this.props.testType === 2) {
        this.setState({
          groupName: groupName
        })
      }

      if (value === item.id) {
        this.updateChoosenAnswers(item);
      }

    });
  };

  onChangeAnswerMulti = e => {
    const answers = this.state.question.answers;
    let value = +e.target.value;

    if (e.target.checked) {
      e.target.parentElement.classList.add('checked');
    } else {
      e.target.parentElement.classList.remove('checked');
    }

    this.setState({
      answer: true,
      answerValue: value
    });
  };

  onClickSendAnswers = e => {
    const answersInput = document.querySelectorAll('.answer__input');
    const currentAnswers = Array.from(answersInput).filter(
      item => item.checked
    );
    const answersValues = currentAnswers.map(item => +item.value);
    const compareAnswers = diff(answersValues, this.state.answersMulti);

    function diff(a, b) {
      return a.filter(function(i) {
        return b.indexOf(i) < 0;
      });
    }

    if (
      compareAnswers.length > 0 ||
      currentAnswers.length !== this.state.answersMulti.length
    ) {
      this.props.updateStep(this.props.step + 1);
    } else {
      this.setState(
        {
          count: this.state.count + 1
        },
        () => {
          this.props.updateCount(this.state.count);
        }
      );
    }

    this.props.updateStep(this.props.step + 1);
  };

  updateChoosenAnswers = async item => {
    if(this.props.testType === 1) {
      await fetch(
          window.location.hostname === 'localhost' ? `http://172.21.0.4/public/answers/fix/${item.id}` :`https://ppc.world/quizzes/api/public/answers/fix/${item.id}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }
      ).then(res => {});
    } else {
      await fetch(
          window.location.hostname === 'localhost' ? `http://172.21.0.4/public/answers/fix/${item.id}` :`https://ppc.world/quizzes/api/public/answers/fix/${item.id}`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }
      ).then(res => {
        this.props.updateGroupResult(this.state.groupName);
        this.props.onClick();
      })
    }
  };

  render() {
    const { question, answer, answerValue, multipleChoice } = this.state;
    const { questions, step, onClick } = this.props;

    return (
      <React.Fragment>
        {question?.answers !== undefined && (
          <div className="question">
            <div className="question__step">
              Вопрос {step}/{questions.length}
            </div>
            <h3 className="h3 question__title">
              {question.text}
              {multipleChoice && (
                <span className="question-small-text">
                  возможно несколько вариантов ответа
                </span>
              )}
            </h3>
            {question.imageUrl !== '' ?  <div className="question-image">
              <img src={`https://ppc.world/quizzes/api${question.imageUrl}`} alt=""/>
            </div> : null}


            <AnswerList
              testType={this.props.testType}
              onChangeAnswer={this.onChangeAnswer}
              onChangeAnswerMulti={this.onChangeAnswerMulti}
              answerList={question.answers}
              answer={answer}
              onClick={onClick}
              onClickSendAnswers={this.onClickSendAnswers}
              answerValue={answerValue}
              multipleChoice={this.state.multipleChoice}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

Question.propTypes = {
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateCount: PropTypes.func.isRequired,
};

export default Question;
